import React from 'react';
import { EventedModal, ModalNames } from '|/app/modals';
import LinkButton from '|/components/carvana-ds/link-button';
import openExternalLink from '|/helpers/open-external-link';
import styles from './seven-day-guarantee-modal.module.css';

const termsUrl = `${process.env.BASE_URL}/help/purchasing-a-car/what-are-the-limits-of-the-7-day-money-back-guarantee`;

export interface SevenDayGuaranteeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SevenDayGuaranteeModal = ({ isOpen, onClose }: SevenDayGuaranteeModalProps) => (
  <EventedModal
    analyticsId={ModalNames.SevenDayGuarantee}
    aria-label="7-Day Money Back Guarantee"
    isOpen={isOpen}
    onClose={onClose}
    mobileStyle="inset"
    desktopWidth="480px"
    animationDurationMs={400}
    contentOverflow={false}
    divLine={false}
  >
    <div className={styles.content} data-testid="pp_seven-day-guarantee-modal">
      <div className={styles.header}>
        <h2 className={styles.title}>7-Day Money Back Guarantee</h2>
        <div className={styles.body}>
          <p className={styles.paragraph}>
            Unlike a traditional dealership, when you receive your Carvana car, you get to actually
            live with it for 7 days. Take it on the freeway, see how it fits in your garage, and how
            you can maneuver it into a parking space at the grocery store. Does the trunk fit your
            child&apos;s stroller or your golf clubs? If you have a trusted mechanic and want an
            outside opinion, feel free to take it in for an inspection.
          </p>
          <p className={styles.paragraph}>
            If you decide to return or exchange your vehicle, all costs other than shipping will be
            refunded or applied toward your exchange. Shipping charges cover Carvana&apos;s costs
            when you choose a vehicle that&apos;s being stored further from your location than other
            similar vehicles, and they may not be refundable if you cancel your order after
            we&apos;ve started transporting the vehicle.
          </p>
        </div>
      </div>

      <LinkButton
        size="md"
        underline={false}
        onClick={() => {
          openExternalLink(termsUrl);
        }}
        data-analytics-id="pp_seven_day_guarantee_terms"
        data-testid="pp_seven-day-guarantee-terms"
      >
        Terms and Conditions
      </LinkButton>
    </div>
  </EventedModal>
);

export default SevenDayGuaranteeModal;
